import { toast } from "react-toastify";
import axios, { isAxiosError as _isAxiosError } from "axios";

import { isArray, isString } from "@/lib/utils";

const agentBaseUrl = import.meta.env.VITE_PUBLIC_AGENT_API_BASE_URL;

export const agentHttpClient = axios.create({
  baseURL: agentBaseUrl,
});

export const isAxiosError = _isAxiosError;

/**
 * FastAPI sends `detail` as a string, or as a list of validation errors.
 */
const getErrorMessage = (detail: unknown): string => {
  if (isString(detail) && detail) {
    return detail;
  }

  if (isArray(detail)) {
    const [firstError] = detail as Array<{ msg?: string } | undefined>;

    if (firstError?.msg) {
      return firstError.msg;
    }
  }

  return "Something went wrong";
};

export const handleAxiosError = (error: unknown, login: () => void): void => {
  if (axios.isAxiosError(error)) {
    if (error.response?.status === 401) {
      login();
    }
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    const detail: unknown = error.response?.data.detail;
    const message = getErrorMessage(detail);
    console.error(message);
    toast.error(message);
  } else {
    /**
     * Not an Axios error — re-throw to propagate to callers.
     */
    throw error;
  }
};
